<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title>
        {{ mercaderia.proveedor.nombre }} {{ mercaderia.comprobante.tipo }}
        {{ mercaderia.comprobante.numero }}
        <v-spacer></v-spacer>
        <v-btn v-if="esAdmin && mercaderia.compra" fab small dark color="green" @click="verCompra()"><v-icon>mdi-eye</v-icon></v-btn>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-if="esAdmin">Usuario</th>
                <th class="text-left">Fecha y Hora</th>
                <th class="text-left">Observacion</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-if="esAdmin">{{mercaderia.usuario.nombre}}</td>
                <td>
                  {{
                    mercaderia.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm")
                  }}
                </td>
                <td>
                  {{mercaderia.observacion}}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Producto</th>
                <th class="text-left">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in mercaderia.productos" :key="item.name">
                <td>{{ item.producto.nombre }}</td>
                <td>{{ item.cantidad }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Mercaderias_Nuevo",
  data() {
    return {
      loading: true,
      mercaderia: {},
    };
  },
  methods: {
    _cerrar() {
      this.$router.go(-1)
    },
    verCompra() {
      this.$router.push('/compras/' + this.mercaderia.compra)
    },
  },
  async created() {
    try {
      const mercaderia = await axios.get(`/remito/${this.id}`);
      this.mercaderia = mercaderia.data;
    } catch (error) {
      this.$router.push(`/mercaderias`);
    }
    this.loading = false;
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    esAdmin() {
      return this.$store.state.datos.roles.includes('superadmin')
    }
  },
};
</script>
